import React from 'react';
import { func } from 'prop-types';
import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import CircularProgress from '@material-ui/core/CircularProgress';

import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';
import LinksTable from './LinksTable';
import { TabContent } from '../../components/TabPanel';

import * as ArchitectActions from '../../actions/architectActions';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import classes from './TableAndSearch.module.css';
import { loader } from './TechniciansList.module.css';

const LinksTableAndSearch = ({
    getLinks,
    handleSort,
    onToggleCreateLinkModal,
    onToggleDeleteLinkModal,
    order,
    orderBy,
    selectedNode,
    links,
    linkType,
    fetchErpLinks,
    currentScopes,
    contactLinksLoading,
    linksLoading,
    ...props
}) => {

    //useEffect(() => {
    //    const init = async () => {
    //        await getLinks();
    //    };

    //    init();
    //}, [selectedNode]);

    const openCreateLink = () => {
        onToggleCreateLinkModal(true);
    };

    const isFullArchitectAllowed = isAllowed(currentScopes, Permissions('architectFull'));

    const handleLinkFilter = searchTerm => {
        if (isEmpty(searchTerm)) {
            fetchErpLinks(selectedNode.type);

            return;
        }

        fetchErpLinks(selectedNode.type, {searchFilter: searchTerm});
    };

    const loading = selectedNode.type === 'contact' ? contactLinksLoading : linksLoading;

    return (
        <TabContent
            classes={{
                root: classes.tabContent
            }}
        >
            <ActionBar
                onSearch={handleLinkFilter}
            >
                <ActionBarItem
                    hidden={!isFullArchitectAllowed}
                    onClick={openCreateLink}
                    type="add"
                >
                    New Link
                </ActionBarItem>
            </ActionBar>
            <div className={classes.scrollHidden}>
                {loading ?
                    <div className={loader}>
                        <CircularProgress size={50} />
                    </div>
                    :
                    <LinksTable
                        isFullArchitectAllowed={isFullArchitectAllowed}
                        order={order}
                        orderBy={orderBy}
                        onSort={property => handleSort(props, property)}
                        onToggleDeleteLinkModal={onToggleDeleteLinkModal}
                        links={links}
                        linkType={linkType}
                        selectedNode={selectedNode}
                    />}
            </div>
        </TabContent>
    );
};

LinksTableAndSearch.defaultProps = {
    getLinks: () => {}
};

LinksTableAndSearch.propTypes = {
    getLinks: func
};

const mapDispatchToProps = {
    ...ArchitectActions
};

const mapStateToProps = state => {
    return {
        currentScopes:       state.core.currentScopes,
        linksLoading:        state.architect.linksLoading,
        contactLinksLoading: state.architect.contactLinksLoading
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LinksTableAndSearch);
